<template>
    <div :class='["tbqr",{twoBox:!isOver}]' v-if='tbdw'>
        <template v-if='!isOver'>
            <div class="redBox">
                <p class='red' v-if='!isBegin'>确认未开始</p>
                <div v-else>
                    <p>确认剩余时间</p>
                    <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
                </div>
            </div>
            <div class="box">
                <table class='show'>
                    <colgroup width='160px'></colgroup>
                    <tr>
                        <td>投标单位</td>
                        <td>{{tbdw.fcqymc}}</td>
                    </tr>
                    <tr>
                        <td>确认时间</td>
                        <td><span v-html='qrsj'></span></td>
                    </tr>
                </table>
                <div class="btnBox" style='margin-top:40px'>
                    <el-button type="primary" @click="getKpdjgb" v-if='sfykpdjgb' :disabled='kpdjgbtbr'>显示开评定结果表</el-button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class='kbjs box'>
                <el-button type="primary rt" @click="getKpdjgb" style='margin-top:20px;margin-right:20px' v-if='sfykpdjgb' :disabled='kpdjgbtbr'>显示开评定结果表</el-button>
                <div class='jsy'>
                    <p>本次开标到此结束！</p>
                    <p>谢谢大家！</p>
                </div>
                <template v-if='isTBR'>
                    <div class="bottom">
                        <p>评标情况快照</p>
                        <el-steps v-if="nodeData.length > 0" :space="500" :active="active" align-center>
                            <el-step 
                                v-for="item in nodeData"
                                :class="item.status == 2? 'statusSuccess':'statusWait'" 
                                :status="item.status == 2? 'success':'wait'" 
                                :key="item.id" 
                                :title="item.nodeName"
                            >
                                <template v-slot:icon>
                                    <img src="@/assets/images/quan.png" alt="">
                                </template>
                                <template v-slot:description>
                                    <el-popover
                                        class="popover"
                                        v-if="item.status == 2"
                                        placement="top"
                                        width="1000"
                                        trigger="hover"
                                        @show="getSnapshoot(item)">
                                        <table-tem
                                            :config="tableConfig"
                                        >
                                            <template v-slot:score="scope">
                                                {{ scope.data.median ? scope.data.median[scope.headkey] : '' }}
                                            </template>
                                            <template v-slot:sort="scope">
                                                {{ scope.data.sort ? '第一中标候选人' : '' }}
                                            </template>
                                        </table-tem>
                                        <el-button slot="reference"></el-button>
                                    </el-popover>
                                </template>
                            </el-step>
                        </el-steps>
                        <span v-else>待评标专家开启评标</span>
                    </div>
                </template>
            </div>
        </template>
        <!-- 开评定弹窗 -->
        <el-dialog
        title="报表"
        :visible.sync="bbVisible"
        :close-on-click-modal="false"
        :fullscreen='true'
        >
            <div class='pdf'>
                <iframe :src="kpdjgbPdf" frameborder="0" width="100%" height="100%"></iframe>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="bbVisible=false">关闭</el-button>
                <el-button type="primary" @click="loadKpdjgb" :disabled="waitLoading">下载</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import tableTem from "@/components/tableTem/index.vue";
import myClock from '../components/clock/clock'
export default {
    name:'tbqr',
    props:['djlcId'],
    components:{
        myClock,
        tableTem,
    },
    data(){
        return{
            waitLoading:false,
            isBegin:false,//招标人是否开始确认
            shenyu:0,
            isSfqr:false,//投标人是否点击确认
            tbdw:'',
            qrsj:'',
            intervalTbqr:'',//定时器
            isOver:false,//主持人是否点击开标结束
            bbVisible:false,
            kpdjgbPdf:'',
            pdfId:'',
            sfykpdjgb:false,
            kpdjgbtbr:true,
            snapshootData: [],
            nodeData: [],
            active: 0,
            visiblepop: false,
            tableConfig: {
                head: [],
                data: [],
                total: 0,
                currentPage: 1,
                pageSize: 10,
                border: true,
            },
        }
    },
    computed:{
        isTBR(){
            return localStorage.getItem('role') == 'B' || null
        },
        websocketUrl(){
            //return "ws://101.71.128.75:18093/websocket/"
            return (window.location.protocol=="http:"?"ws://":"wss://")+window.location.host+'/api/v1/websocket/'
        },
        sectionId() {
            return localStorage.getItem('bdId') || null
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.kbqrTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.tbdw=res.data.data.tbdw;
                    this.isSfqr=res.data.data.tbdw.sfqr=="1"?true:false;
                    this.isOver=res.data.data.kbxm.zt=="2"?true:false
                    this.sfykpdjgb=res.data.data.sfykpdjgb;
                    this.kpdjgbtbr=res.data.data.kbxm.kpdjgbtbr==0?true:false;
                    if(res.data.data.kbxm.qrsj){
                        this.isBegin=true;
                        this.shenyu=res.data.data.sfszqrsj;
                        if(this.shenyu>=1000){
                            if(this.isSfqr){
                                this.qrsj=this.$moment(res.data.data.tbdw.qrsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qrsj='';
                                this.tbqrshenyuFun();
                            }
                        }else{
                            this.qrsj=res.data.data.tbdw.qrsj?this.$moment(res.data.data.tbdw.qrsj).format("YYYY-MM-DD HH:mm:ss"):'';
                        }
                    }else{
                        this.isBegin=false;
                        this.isSfqr=false;
                        this.qrsj=''
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击确认按钮操作
        tbrDo(lx){
            if(lx=='tbqr'){
                this.$confirm('确认开标过程无误！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let para={}
                    let _this=this
                    this.$api.djqrTbr(para).then(res=>{
                        if(res.data.meta.success){
                            _this.$message({
                                type:'success',
                                message:'确认成功！'
                            })
                        }
                        clearInterval(_this.intervalTbqr);
                        _this.intervalTbqr=null;
                        let obj={
                            lx:'tb',
                            data:{
                                index:4,
                                msg:'2',
                                all:true
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }).catch(()=>{})
                }).catch(() => {});
            }
        },
        //计算剩余时间倒计时
        tbqrshenyuFun(){
            var _this=this;
            var time=this.shenyu
            var flag=false
            clearInterval(this.intervalTbqr);
            this.intervalTbqr=null;
            this.intervalTbqr=setInterval(function(){
                time=time-2000
                if(time<1000){
                    if(!flag){
                        flag=true
                        if(!_this.isOver){
                            let obj={
                                lx:'tb',
                                data:{
                                    index:4,
                                    msg:'2',
                                    all:false
                                }
                            }
                            _this.$emit('send',JSON.stringify(obj))
                        }else{
                            _this.getData();
                        }
                    }
                    clearInterval(_this.intervalTbqr);
                    _this.intervalTbqr=null;
                    return;
                }
            },2000)
        }, 
         //打开开评定结果弹窗
        getKpdjgb(){
            let para={}
            this.$api.getKpdjgb(para).then(res=>{
                if(res.data.meta.success){
                    this.kpdjgbPdf=res.data.data.pdfFile;
                    this.pdfId=res.data.data.id
                    this.bbVisible=true;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        loadKpdjgb(){
            let para={
                id:this.pdfId
            }
            this.waitLoading=true
            this.$api.loadKpdjgb(para).then(res=>{
                let fileName = decodeURI(res.headers["content-disposition"].split("=")[1]);
                let blob = new Blob([res.data])
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName)
                } else {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = fileName
                    link.click()
                    //释放内存
                    window.URL.revokeObjectURL(link.href)
                }
                this.waitLoading=false
            }).catch(()=>{})
        },

        // websocket
        // init(){
        //     let wsUrl=this.websocketUrl+this.sectionId
        //     //let wsUrl='ws://tpb.zhaotx.cn/websocket/'+this.sectionId+'?'+this.token
        //     if('WebSocket' in window){
        //         this.websocket=new WebSocket(wsUrl)
        //     }else{
        //         console.log('您的浏览器不支持socket')
        //         new Error('您的浏览器不支持socket')
        //     }
        //     this.websocket.onopen = this.websockOpen; // 监听打开
        //     this.websocket.onclose = this.websockClose; // 监听关闭
        //     this.websocket.onerror = this.websockError; //监听异常
        //     this.websocket.onmessage = this.websockMessage;//监听服务器发送的消息
        // },
        // longStart(){
        //     clearInterval(this.timeoutobj);
        //     clearTimeout(this.serverTimeout);
        //     this.timeoutobj=null;
        //     this.serverTimeout=null
        //     this.timeoutobj=setInterval(()=>{
        //         let data={
        //             type:999
        //         }
        //         if(this.websocket.readyState===1){
        //             this.websocket.send(JSON.stringify(data))
        //         }
        //         this.serverTimeout=setTimeout(()=>{
        //             this.lockReconnect=true
        //             this.websocket.close()
        //         },2000)
        //     },10000)
        // },
        // websockOpen(e) {
        //     console.log('连接上websocket',e)
        //    this.longStart(); //开启心跳检测
        // },
        // websockClose(e) {
        //     console.log('关闭websocket')
        //     if(this.lockReconnect){
        //         this.init()
        //     }
        // },
        // websockError(e) {
        //     console.log("websocket链接错误", e.target.url);
        //     this.init()
        // },
        // websockMessage(e) {
        //     console.log('接受到消息',e)
        //     this.longStart(); //开启心跳检测
        //     let data=JSON.parse(e.data)
        //     let {type,secondaryProcedureId}={...data}
        //     if(type==1){
        //         //所有专家提交
        //         console.log('websocket专家提交')
        //         this.progress(secondaryProcedureId);
        //     }
        // },
        // 获取流程
        evaluationProcess() {
            let para={
                sectionId: this.sectionId
            }
            this.$api.evaluationProcess(para).then(res=>{
                if(res.data.success){
                    this.nodeData = res.data.data
                    const actives = this.nodeData.filter(item => {
                        return item.status == 2
                    })
                    this.active = actives.length
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.message
                    })
                }
            }).catch(()=>{})
        },
        getSnapshoot(item){
            //其他操作逻辑
            let para={
                sectionId: this.sectionId,
                nodeType: item.nodeType,
            }
            this.$api.getSnapshoot(para).then(res=>{
                if(res.data.success){
                    this.snapshootData = JSON.parse(decodeURI(res.data.data.htmlText))
                    this.tableConfig.head = this.snapshootData.columns.length> 0 ? this.snapshootData.columns : []
                    this.tableConfig.data = this.snapshootData.data.length> 0 ? this.snapshootData.data : []
                    if(item.nodeType == 'swb' || item.nodeType == '1') {
                        this.tableConfig.data.map(item => {
                            item.median = item.median.split(',')
                            item.N2 = item.median[0]
                            item.controlTotal = item.median[1]
                            item.floorPrice = item.median[2]
                            item.offerMean = item.median[3]
                            return item
                        })
                    }
                }else{
                    this.tableConfig.head = []
                    this.tableConfig.data = []
                    this.$message({
                        type:'error',
                        message:res.data.message
                    })
                }
            }).catch(()=>{})
        },
    },
    mounted(){
        clearInterval(this.intervalTbqr);
        this.intervalTbqr=null;
        this.getData();
        // if(!this.websocket){
        //     this.init()
        // }else{
        //     console.log('nourl')
        //     this.websocket.close();
        //     this.websocket=null
        // }
        this.evaluationProcess()
    },
    beforeDestroy(){
        clearInterval(this.intervalTbqr);
        this.intervalTbqr=null;
    }
}
</script>
<style lang="less">
.tbqr{
    .el-dialog__body{
        height:100%;
        .pdf{
            height:calc(~"100% - 60px");
            margin-bottom:10px;
        }

    }
}
</style>
<style lang="scss" scoped>
.bottom{
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 20px 0;
    .el-steps{
        margin: 20px 0;
    }
    img{
        width: 24px;
        height: 24px;
    }
    p{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
        margin-left: 50px;
    }
    span{
        display: block;
        margin: 20px 0 0 50px;
        font-size: 18px;
    }
}
::v-deep .el-step__head.is-success{
    color: white;
    border-color: #0060b2;
}
::v-deep .statusSuccess .el-step__icon.is-text{
    background-color: #0060b2;
}
::v-deep .el-step__title.is-success{
    color: #0060b2;
}
.popover{
    .el-button{
        height: 24px;
        opacity: 0;
        z-index: 100;
        position: relative;
        bottom: 58px;
    }
}
</style>